import React from "react";
import { ConfigProvider, App as AntdApp } from "antd";
import { useThemeMode } from "./ThemeContext";

export function ThemeConfigProvider({ children }) {
  const { themeConfig } = useThemeMode();

  return (
    <ConfigProvider theme={themeConfig}>
      <AntdApp>{children}</AntdApp>
    </ConfigProvider>
  );
}

export default ThemeConfigProvider;
